import { Component, ElementRef, OnInit, Signal, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, RouterModule } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { selectServices } from '../../store/selectors/app.selectors';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { ServiceListItem } from '../../services/service.common.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    RouterModule,
    ReactiveFormsModule,
    HeaderComponent,
    CommonModule,
    FooterComponent
  ],
  templateUrl: './main-page.component.html'
})
export class MainPageComponent implements OnInit {

  public activeTab: any;

  @ViewChild('servicesTab', { static: true })
  servicesTab: ElementRef | undefined;

  public services: Signal<ServiceListItem[]> = this.store$.selectSignal(selectServices);

  public form = new FormGroup({
    query: new FormControl('', [Validators.required])
  });

  constructor(
    private store$: Store,
    private router: Router
  ) {
    if (environment.production) {
      document.body.classList.add('js-show-gov-menu');
    }

  }

  public onSearch(): void {
    if (this.form.valid) {
      this.router.navigate(['e-uslugi'], { queryParams: { 'query': this.form.value.query } });
    }
  }

  public ngOnInit(): void {
    this.activeTab = this.servicesTab?.nativeElement;
  }
}
